<app-update-banner />

@if (isLoading()) {
  <div class="loading-overlay">
    <div class="loading-spinner"></div>
  </div>
}

@if (showSubscriptionAlert()) {
  <app-subscription-alert-modal />
}

<router-outlet></router-outlet>
